/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-sale-credit.reducer';

export const PharmacySaleCreditDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacySaleCreditEntity = useAppSelector(state => state.pharmacySaleCredit.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacySaleCreditDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.detail.title">PharmacySaleCredit</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.id}</dd>
          <dt>
            <span id="totalAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.totalAmount">Total Amount</Translate>
            </span>
            <UncontrolledTooltip target="totalAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.totalAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.totalAmount}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.paidAmount">Paid Amount</Translate>
            </span>
            <UncontrolledTooltip target="paidAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.paidAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.paidAmount}</dd>
          <dt>
            <span id="pendingAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.pendingAmount">Pending Amount</Translate>
            </span>
            <UncontrolledTooltip target="pendingAmount">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.pendingAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.pendingAmount}</dd>
          <dt>
            <span id="creditType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.creditType">Credit Type</Translate>
            </span>
            <UncontrolledTooltip target="creditType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.creditType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.creditType}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.addedById">Added By Id</Translate>
            </span>
            <UncontrolledTooltip target="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.addedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.modifiedById">Modified By Id</Translate>
            </span>
            <UncontrolledTooltip target="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.modifiedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.modifiedById}</dd>
          <dt>
            <span id="closureStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.closureStatus">Closure Status</Translate>
            </span>
            <UncontrolledTooltip target="closureStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.closureStatus" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.closureStatus}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.cursor}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.timestampentry">Timestampentry</Translate>
            </span>
            <UncontrolledTooltip target="timestampentry">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.timestampentry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.lastUpdated}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.addedByType">Added By Type</Translate>
            </span>
            <UncontrolledTooltip target="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.addedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.modifiedByType">Modified By Type</Translate>
            </span>
            <UncontrolledTooltip target="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.modifiedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.modifiedByType}</dd>
          <dt>
            <span id="cancelledReason">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.cancelledReason">Cancelled Reason</Translate>
            </span>
            <UncontrolledTooltip target="cancelledReason">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.cancelledReason" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.cancelledReason}</dd>
          <dt>
            <span id="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.billNumber">Bill Number</Translate>
            </span>
            <UncontrolledTooltip target="billNumber">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.billNumber" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.billNumber}</dd>
          <dt>
            <span id="amended">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.amended">Amended</Translate>
            </span>
            <UncontrolledTooltip target="amended">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.amended" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.amended ? 'true' : 'false'}</dd>
          <dt>
            <span id="preGst">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.preGst">Pre Gst</Translate>
            </span>
            <UncontrolledTooltip target="preGst">
              <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.preGst" />
            </UncontrolledTooltip>
          </dt>
          <dd>{pharmacySaleCreditEntity.preGst ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.pharmacy ? pharmacySaleCreditEntity.pharmacy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.consumer">Consumer</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.consumer ? pharmacySaleCreditEntity.consumer.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.patient">Patient</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.patient ? pharmacySaleCreditEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.salePayment">Sale Payment</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.salePayment ? pharmacySaleCreditEntity.salePayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.refundPayment">Refund Payment</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.refundPayment ? pharmacySaleCreditEntity.refundPayment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.amendedFrom">Amended From</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.amendedFrom ? pharmacySaleCreditEntity.amendedFrom.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.amendedTo">Amended To</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.amendedTo ? pharmacySaleCreditEntity.amendedTo.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.invoiceType">Invoice Type</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.invoiceType ? pharmacySaleCreditEntity.invoiceType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.urType">Ur Type</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.urType ? pharmacySaleCreditEntity.urType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.saleBill">Sale Bill</Translate>
          </dt>
          <dd>{pharmacySaleCreditEntity.saleBill ? pharmacySaleCreditEntity.saleBill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-sale-credit" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-sale-credit/${pharmacySaleCreditEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacySaleCreditDetail;
